import type { AttributeChangeProps } from '../../../types';
import { TextField } from '@flos/react-ui';
import { isOpcDataFilledAtom } from '../../../../../recoil/atoms/isOpcDataFilledAtom';
import { useRecoilValue, useSetRecoilState } from 'recoil';
import { useHippoText } from '../../../../../hooks/useHippoText';
import { opcInfoAtom } from '../../../../../recoil/atoms/opcInfoAtom';
import { getCoverableInfoSelector } from '../../../../../recoil/selectors/getCoverableInfoSelector';
import { isOpcFetchingAtom } from '../../../../../recoil/atoms/isOpcFetchingAtom';
import { getOPCReceiptPageChangeTypeAtom } from '../../../../../recoil/atoms/getOPCReceiptPageChangeTypeAtom';
import { getOPCCoverableAttributeSelector } from '../../../../../recoil/selectors/getOPCCoverableAttributeSelector';

const PetChipIdChange = ({ updateCoverableAttribute }: AttributeChangeProps): React.JSX.Element => {
    const setIsOpcDataFilled = useSetRecoilState(isOpcDataFilledAtom);
    const getHippoText = useHippoText();
    const opcInfo = useRecoilValue(opcInfoAtom);
    const currentOPCAttribute = useRecoilValue(getOPCCoverableAttributeSelector);
    const currentChipId =
        opcInfo.productName === 'topdanmark_dog'
            ? currentOPCAttribute.dog?.chipId
            : currentOPCAttribute.cat?.chipId;
    const coverableInfo = useRecoilValue(getCoverableInfoSelector);
    const isOpcFetching = useRecoilValue(isOpcFetchingAtom);
    const setOPCReceiptPageChangeType = useSetRecoilState(getOPCReceiptPageChangeTypeAtom);

    return (
        <>
            <h6>
                {getHippoText('DSS-PET-OPC-EDIT-CHIP-NUMBER-QUESTION', {
                    pet_name:
                        opcInfo.productName === 'topdanmark_dog'
                            ? coverableInfo.petName ?? ''
                            : 'kattens'
                })}
            </h6>
            <TextField
                id="ChipIdChange"
                label={getHippoText('DSS-OPC-INPUT-LABEL')}
                onBlur={(e) => {
                    updateCoverableAttribute({ chipId: e.target.value });
                    setIsOpcDataFilled(e.target.value !== '');
                    setOPCReceiptPageChangeType('updateMissingAttribute');
                }}
                disabled={isOpcFetching}
                value={currentChipId}
            />
        </>
    );
};

export default PetChipIdChange;
